/**
 * Verweise auf Quellen im Netz - Aufbereitung der Eingabe.
 *
 * Liegt hier und nicht in der Oberfläche, weil beide Seiten dasselbe
 * Verständnis davon brauchen, was eine brauchbare Adresse ist: die Maske
 * bereitet auf, die API lehnt ab. Und weil sich das so testen lässt.
 */
/**
 * Eine getippte Adresse brauchbar machen.
 *
 * Wer "data.matricula-online.eu/..." aus der Adresszeile kopiert, hat das
 * "https://" oft nicht mit dabei - das zu ergänzen ist freundlicher als eine
 * Fehlermeldung. Ohne Beschriftung wird der Rechnername genommen, damit in
 * der Liste nicht eine nackte Adresse steht.
 *
 * Rückgabe: der fertige Verweis, `null` für eine leere Zeile (die fällt
 * einfach weg), `"ungueltig"` für alles, was kein http(s) ist. Letzteres ist
 * keine Förmlichkeit: `javascript:` in einem Link, den später jemand
 * anklickt, wäre eine offene Tür.
 */
export function verweisAufbereiten(v) {
    const roh = v.url.trim();
    if (!roh)
        return null;
    // Hat die Eingabe schon ein Schema (irgendwas vor "://" oder ":")?
    const url = /^[a-z][a-z0-9+.-]*:/i.test(roh) ? roh : `https://${roh}`;
    if (!/^https?:\/\//i.test(url))
        return "ungueltig";
    let geprueft;
    try {
        geprueft = new URL(url);
    }
    catch {
        return "ungueltig";
    }
    if (!geprueft.hostname)
        return "ungueltig";
    const titel = v.titel.trim() || geprueft.hostname.replace(/^www\./, "");
    return { titel, url };
}
//# sourceMappingURL=verweis.js.map